export class CommentCountModel {
    _id: string | undefined;
    commentCount: number | undefined;
    postId: string | undefined;
    sourceId: string | undefined;
    sourceType: string | undefined;
}